<template>
  <div class="custom-popover" v-if="showCopyBtn || order.is_show_invoice_button">
    <!-- 触发按钮 -->
    <base-popover-with-close
      ref="basePopover"
      :hide-popover="index !== canShowCopyOrderTipsOid || isAdmin"
      position="top"
      storage-key="isShowCopyOrderTips"
      content="选错签证一键切换，新订单复用历史资料更快捷"
    >
      <el-button
        class="custom-button"
        type="text"
        @click.stop="togglePopover"
      >
        更多
      </el-button>
    </base-popover-with-close>
    
    <!-- 弹出层 -->
    <div
      v-if="isPopoverVisible"
      class="popover-content"
      ref="popover"
    >
      <div v-if="showCopyBtn" class="menu-item" @click="copyOrder">切换产品</div>
      <div v-if="order.is_show_invoice_button" class="menu-item" @click="goToInvoiceManage">开发票</div>
    </div>
  </div>
</template>

<script>
import BasePopoverWithClose from '../../../components/common/popover/base-popover-with-close.vue';
import sensorsdata from 'sa-sdk-javascript';

export default {
  name: 'button-more',
  components: {
    BasePopoverWithClose,
  },
  props: {
    order: Object,
    orderList: {
      type: Array,
      default: () => ([]),
    },
    index: Number,
    isAdmin: Boolean,
  },
  data() {
    return {
      showTips: Boolean,
      isPopoverVisible: false, // 控制弹出层的显示
    };
  },
  computed: {
    showCopyBtn() {
      return !this.order.ota_info && !this.order.enable_api && !this.isAdmin;
    },
    // 订单列表第一个不是飞猪并且不是api的订单才展示
    canShowCopyOrderTipsOid() {
      const index = this.orderList.findIndex(item => !item.ota_info && !item.enable_api);
      return index;
    },
  },
  methods: {
    togglePopover() {
      this.isPopoverVisible = !this.isPopoverVisible;
    },
    copyOrder() {
      this.isPopoverVisible = false; // 操作后隐藏弹出层
      this.$refs.basePopover.onClose();
      sensorsdata.track('ElementClick', {
        pagefrom: 'PC',
        click_content: '【订单列表】修改产品',
      });
      this.$router.push({
        name: 'EditProduct',
        query: {
          id: this.order.user_order_id,
        },
      });
    },
    handleClickOutside(event) {
      const popover = this.$refs.popover;
      if (popover && !popover.contains(event.target)) {
        this.isPopoverVisible = false; // 点击外部隐藏
      }
    },
    goToInvoiceManage() {
      this.$router.push({ name: 'invoiceManage' });
    },
  },
  mounted() {
    // 添加全局点击监听
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    // 移除全局点击监听
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style scoped lang="less">
.custom-popover {
  position: relative;
  display: inline-block;
}
.popover-content {
  position: absolute;
  width: 76px;
  background: #fff;
  left: 50%;
  transform: translateX(-50%);
  top: 100%;
  box-shadow: 0 3px 11px -1px rgba(0,0,0,0.2);
  border-radius: 4px;
  z-index: 20;
  .menu-item{
    cursor: pointer;
    font-size: 14px;
    color: #2F333D;
    height: 30px;
    display: flex;
    align-items: center;
    padding-left: 10px;
    position: relative;
    &::after{
      content: '';
      position: absolute;
      bottom: 0;
      left: 8px;
      right: 8px;
      height: 1px;
      background: #E9EEF2;
    }
    &:last-child{
      &::after{
        display: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/components/button-more.vue